<template>
  <div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="storeList flex_center" v-for="(techItem,techIndex) in techList" :key="techIndex">
        <!--技师头像-->
        <div class="tech__headBox" v-if="techItem.type=='2'">
          <img class="tech__headImg seniorTech" :src="techItem.thumb?techItem.thumb:techItem.avatar" alt />
          <img class="tech__head_crown" src="../../../static/img/crown_icon.png" alt />
        </div>
        <div class="tech__headBox" v-if="techItem.type=='0'">
          <img class="tech__headImg" :src="techItem.thumb?techItem.thumb:techItem.avatar" alt />
        </div>
        <!--技师内容-->
        <div class="storeList__content">
          <div class="flex_center techList__title">
            <span>{{techItem.name}}</span>
            <div class="detail_star">
              <span v-for="(item,index) in 5" :key="index">
                <van-icon class="star" size="15px" name="star" v-if="techItem.score > index" :color="star_active" />
                <van-icon class="star" size="15px" name="star" v-else/>
              </span>
            </div>
          </div>
          <div class="col_999 fs_12">
            <p>{{techItem.levelname}}</p>
            <div class="flex techList__line">
              <div>个人编号：{{techItem.num_id}}</div>
              <template v-if="techItem.status==1">
                <div v-if="techItem.use=='0'" class="techList__btn">空闲</div>
                <div v-if="techItem.use=='1'" class="techList__btn techList__btn2">服务中</div>
              </template>
             
              <div v-if="techItem.status=='2'" class="techList__btn techList__btn3">休息中</div>
              <div v-if="techItem.status=='0'" class="techList__btn techList__btn3">下架中</div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
  export default {
    name: "store_tech",
    data(){
      return{
        star_active: "#F9CE06",   //星星
        store_id:0,
        //技师列表
        techList: [
          // {
          //   type:'2',
          //   headImg: '../../static/img/tech_head2.png',
          //   name: '成技师',
          //   grade:'首席技师',
          //   star_level:5,
          //   perNum:"1234444222",
          //   state:'0',
          // },{
          //   type:'0',
          //   headImg: '../../static/img/tech_head1.png',
          //   name: '成技师',
          //   grade:'技师',
          //   star_level:4,
          //   perNum:"1234444222",
          //   state:'1',
          // },{
          //   type:'0',
          //   headImg: '../../static/img/tech_head1.png',
          //   name: '成技师',
          //   grade:'技师',
          //   star_level:5,
          //   perNum:"1234444222",
          //   state:'2',
          // },
        ],
        loading:false,
        finished:true
      }
    },
    created(){
      this.store_id  =this.$route.query.store_id
      this.get_tech();
    },
    methods: {
      get_tech(){
        this.axios({
          url: this.api.store.store_select_tech,
          data: {
            store_id:this.store_id
          }
        }).then(res => {
          if (res.error === 0) {
            this.techList = res.tech_list;
           
          }
        });
      },
      // onLoad() {
      //   // 异步更新数据
      //   setTimeout(() => {
      //     for (let i = 0; i < 3; i++) {
      //       this.techList.push(this.techList[0]);
      //     }
      //     // 加载状态结束
      //     this.loading = false;

      //     // 数据全部加载完成
      //     if (this.techList.length >= 20) {
      //       this.finished = true;
      //     }
      //   }, 500);
      // }
    }
  }
</script>

<style scoped>
  @import '../../assets/css/store.css';
  @import '../../assets/css/technician.css';
  .techList__btn2{
    background: #EC8B48;
  }
  .techList__btn3{
    background: #EEEEEE;
    color: #666;
  }
</style>



// WEBPACK FOOTER //
// src/views/store/store_tech.vue